var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _circle3, _path11, _path12, _circle4, _circle5, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 411.178,
    cy: 284.178,
    r: 184.178,
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.864 381.751h401.833c15.348 0 27.789-11.289 27.789-25.212v-14.991c0-13.923-12.441-25.212-27.789-25.212H234.864c18.38 18.23 18.7 46.085.739 64.656l-.739.759z",
    fill: "#1976d2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.493 323.829h202.21c13.923 0 25.212 11.289 25.212 25.212s-11.289 25.212-25.212 25.212H240.478c9.445-15.467 9.424-34.998.015-50.424z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.954 244.817c-.883-1.514.455-3.264 2.49-3.264h320.021c25.083 0 45.414 16.778 45.414 37.482 0 20.698-20.331 37.476-45.414 37.476H255.361c-2.045 0-3.383-1.761-2.494-3.279 12.667-21.664 12.636-46.85.087-68.415z",
    fill: "#243B52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.506 249.619h214.717c15.86 0 28.719 12.859 28.719 28.718v2.154c0 15.859-12.859 28.718-28.719 28.718H255.051c9.621-19.097 9.724-40.503.455-59.59z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M642.419 238.222H435.897c-18.312 0-33.16-16.009-33.16-35.757 0-19.748 14.848-35.757 33.16-35.757h206.522c-15.787 19.825-16.401 48.905-1.472 69.485l1.472 2.029z",
    fill: "url(#d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.459 202.465c0-19.748 15.017-35.757 33.541-35.757h207.179c.965 0 1.745-.842 1.74-1.87-.01-1.022-.79-1.838-1.74-1.838H317.517c-20.445 0-37.017 17.667-37.017 39.465 0 21.798 16.572 39.465 37.017 39.465h328.662c.955 0 1.73-.821 1.74-1.833.01-1.028-.77-1.87-1.74-1.87H439c-18.524-.005-33.541-16.014-33.541-35.762z",
    fill: "#1976d2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M373.861 280.935c0-4.14 5.243-7.497 11.704-7.497h25.755c-4.904 0-8.876 2.546-8.876 5.687l.122 80.357-14.23-10.334-14.503 10.334.028-78.547z",
    fill: "#E1E4E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135 381.617h597.087c18.54 0 33.573 15.033 33.573 33.572v28.238c0 18.54-15.033 33.573-33.573 33.573H135l.315-.325c25.542-26.586 25.403-68.638-.315-95.058z",
    fill: "#243B52"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.571 395.736h319.19c18.54 0 33.573 15.033 33.573 33.572 0 18.54-15.033 33.573-33.573 33.573H145.576c11.734-20.791 11.718-46.375-.005-67.145z",
    fill: "url(#e)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 141.5,
    r: 5.5,
    stroke: "#E1E4E5",
    strokeWidth: 3.312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 652.822,
    cy: 272.822,
    r: 4.822,
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m583.429 130.607-14.594 5.706.924-15.643 14.592-5.702-.922 15.639z",
    stroke: "#E1E4E5",
    strokeWidth: 4.206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M200.418 347.872c3.894-3.405 5.006-10.243 5.006-10.243s-7.547-.517-11.44 2.888c-3.894 3.406-5.613 7.814-3.835 9.846 1.778 2.032 6.374.917 10.269-2.491zm501.705 7.652c-5.897-5.158-7.581-15.514-7.581-15.514s11.429-.783 17.326 4.375c5.897 5.157 8.5 11.834 5.808 14.911-2.693 3.078-9.653 1.39-15.553-3.772z",
    fill: "#E1E4E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.499,
    cy: 285.106,
    r: 9.646,
    transform: "rotate(136.121 167.499 285.106)",
    fill: "#E1E4E5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 6.735,
    transform: "scale(1 -1) rotate(-43.879 -29.23 -1025.314)",
    fill: "#E1E4E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M196.209 216.418 186 206.209 196.209 196l10.209 10.209-10.209 10.209zm489-4 10.209-10.209L685.209 192 675 202.209l10.209 10.209z",
    stroke: "#E1E4E5",
    strokeWidth: 5.42,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 419.032,
    y1: 674.876,
    x2: 407.673,
    y2: -300.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 349.347,
    y1: 402.523,
    x2: 349.692,
    y2: 268.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 371.796,
    y1: 342.619,
    x2: 372.245,
    y2: 184.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 517.468,
    y1: 278.317,
    x2: 518.126,
    y2: 88.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 314.431,
    y1: 500.526,
    x2: 314.825,
    y2: 322.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.127cf548960138a285c4b88a81015765.svg";
export { ForwardRef as ReactComponent };